import { Component, OnInit, Input } from '@angular/core';
import { faEnvelope, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import { XpService } from '../xp.service'

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  @Input() part: any

  envelope = faEnvelope
  exclamationTriangle = faExclamationTriangle

  constructor(public xp: XpService) { }

  ngOnInit() {
  }

  invite(e, customer) {
    customer.error = false
    customer.loading = true
    this.xp.invite(this.part.service, { id: customer._id, part: this.part._id }).subscribe((data: any) => {
console.log('-- data ok --')
console.log(data)
      if(data.value) {
        customer.lastInvite = data.value.lastInvite
      }
    }, (error) => {
console.log('-- failed request --')
      // Error handling
      customer.error = true
      customer.loading = false
    }, () => {
      // Finally
console.log('-- Finally --')
      customer.loading = false
    })
  }
}
